import { render, staticRenderFns } from "./UserLayout2.vue?vue&type=template&id=691dfbd2&scoped=true&"
import script from "./UserLayout2.vue?vue&type=script&lang=js&"
export * from "./UserLayout2.vue?vue&type=script&lang=js&"
import style0 from "./UserLayout2.vue?vue&type=style&index=0&id=691dfbd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691dfbd2",
  null
  
)

export default component.exports